import React from "react";
import ModalLayout from "app/components/Layouts/ModalLayout/ModalLayout";
import { useTranslation } from "react-i18next";
import styles from "./styles.module.scss";

type CustomPromptActions = {
  onCancel: () => void;
  onConfirm: () => void;
  onConfirmFollowing?: () => void;
};

type CustomPromptData = {
  isOpen: boolean;
  title: string;
  titleIcon?: boolean;
  content?: string | React.ReactNode;
  confirmText?: string;
  cancelText?: string;
  confirmFollowingText?: string;
  isRecurring?: boolean;
  confirmDanger?: boolean;
  operation?: "delete" | "edit" | "custom";
  isLoading?: boolean;
};

type PropsDef = { data: CustomPromptData; actions: CustomPromptActions };

export default function CustomStripeProgramPrompt({ data, actions }: PropsDef) {
  const { t } = useTranslation();

  const primaryBtnClass =
    data.confirmDanger || data.operation === "delete"
      ? styles.btn_danger
      : "btn-primary";

  return (
    <ModalLayout isOpen={data.isOpen} classNames={styles.modal}>
      <div className={styles.confirmation_modal_content}>

        <div className={styles.close_button} onClick={actions.onCancel}>
          <i className="ico ico-x" />
        </div>

        <div className={styles.title}>
          {data.titleIcon ? (
            <h1>stripe</h1>
          ) : (
            <i className="ico ico-dollar-circle" aria-hidden="true" />
          )}
          <h2>{data.title}</h2>
        </div>

        {data.content && <div className={styles.content}>{data.content}</div>}

        <div className={styles.actions}>
          <button
            type="button"
            className={`btn ${primaryBtnClass}`}
            onClick={actions.onConfirm}
            disabled={data.isLoading}
          >
            {data.isLoading ? (
              <>
                <i className="ico ico-spinner" />
                {" "}
                {t("Loading...")}
              </>
            ) : (
              data.isRecurring
                ? data.confirmText || t("Only this")
                : data.confirmText || t("Confirm")
            )}
          </button>

          {data.isRecurring && actions.onConfirmFollowing && (
            <button
              type="button"
              className={`btn ${primaryBtnClass}`}
              onClick={actions.onConfirmFollowing}
            >
              {data.confirmFollowingText || t("This and following")}
            </button>
          )}

          <button
            type="button"
            className={`btn ${styles.cancel_button}`}
            onClick={actions.onCancel}
          >
            {data.cancelText || t("Cancel")}
          </button>
        </div>
      </div>
    </ModalLayout>
  );
}
